var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardPage',{attrs:{"section":9,"page":_vm.page,"nextDisabled":_vm.nextDisabled,"next":_vm.next}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }